import addButton from './addButton';
import buttons from './buttons';

export default {
  addButton,
  buttons
};
